import { supabaseClient } from 'src/auth/supabase';

export type AuthSession = string | null;

export const authSession = async (): Promise<AuthSession | null> => {
    const { data, error } = await supabaseClient.auth.getSession();

    if (error || !data.session) return null;

    const userId = data.session.user?.id;
    const accessToken = data.session.access_token;

    if (!userId || !accessToken) {
        return null;
    }
    return accessToken;
};
